import { CFieldType, Email } from "../../../../types/RecordInterfaces";
import { Tooltip, Whisper } from "rsuite";
import { useRef, useState } from "react";
import AppTooltip from "../../../../elements/AppTooltip";

interface Props {
  fieldType: "Email" | "Phone" | "URL";
  itemId: string;
  setIsEditing: (bool: boolean) => void;
  complexVal: CFieldType;
  existingValue: CFieldType;
  onChange: (value: any) => void;
  setOptionValue: (prev: Email) => void;
}

const Options = ({
  fieldType,
  itemId,
  setIsEditing,
  complexVal,
  existingValue,
  onChange,
  setOptionValue,
}: Props) => {
  const [copied, setCopied] = useState(false);
  const copiedRef = useRef<NodeJS.Timeout>();

  return (
    <div className="d-flex align-items-center ml-2 gap-1">
      <Whisper
        trigger="hover"
        placement="bottom"
        speaker={<Tooltip>{copied ? "Copied to clipboard!" : "Copy"}</Tooltip>}
      >
        <i
          className={`mdi mdi-${
            copied ? "check text-primary" : "content-copy"
          } cursor-pointer text-primary--hover`}
          style={{ fontSize: 18 }}
          onClick={onCopy}
        />
      </Whisper>
      <AppTooltip
        useTooltip
        content={complexVal?.Primary ? "Remove Primary" : " Set as Primary"}
        placement="bottom"
      >
        <i
          className={`mdi text-warning mdi-star${
            complexVal?.Primary ? "" : "-outline"
          } cursor-pointer`}
          style={{ fontSize: 18 }}
          onClick={() => {
            setPrimary(itemId);
            setIsEditing(false);
          }}
        />
      </AppTooltip>
      {fieldType === "Email" && (
        <AppTooltip useTooltip content="Send Email" placement="bottom">
          <i
            className="mdi mdi-email mr-1 cursor-pointer"
            style={{ fontSize: 18 }}
            onClick={() => {
              window.open("mailto:" + existingValue.Email);
              setIsEditing(false);
            }}
          />
        </AppTooltip>
      )}
      {fieldType === "Phone" && (
        <i
          className="mdi mdi-phone mr-1 cursor-pointer"
          style={{ fontSize: 18 }}
          onClick={() => {
            window.open(
              `tel:${existingValue.Phone}${
                existingValue?.Extension && `p${existingValue?.Extension}`
              }`
            );
            setIsEditing(false);
          }}
        />
      )}
      {fieldType === "URL" && (
        <AppTooltip useTooltip content="Open In New Tab" placement="bottom">
          <i
            className="mdi mdi-open-in-new mr-1 cursor-pointer"
            onClick={() => window?.open?.(existingValue.URL, "_blank")}
            style={{ fontSize: 18 }}
          />
        </AppTooltip>
      )}
      <AppTooltip useTooltip content="Delete" placement="bottom">
        <i
          className="mdi mdi-delete-outline text-danger cursor-pointer"
          onClick={() => {
            deleteItem(itemId);
            setIsEditing(false);
          }}
          style={{ fontSize: 18 }}
        />
      </AppTooltip>
    </div>
  );

  function deleteItem(id: string) {
    onChange((prev: Array<Email>) => prev.filter((val) => val.id !== id));
  }

  function setPrimary(id: string) {
    onChange((prev: Array<Email>) => {
      const found = prev.findIndex((val) => val.id === id);
      const newValues = structuredClone(prev);
      newValues.forEach((element: Email) => (element.Primary = false));
      newValues[found].Primary = true;
      setOptionValue(newValues[found]);
      return [...newValues];
    });
  }

  function onCopy() {
    navigator.clipboard.writeText(complexVal[fieldType] as string);
    setCopied(true);
    clearTimeout(copiedRef.current);
    copiedRef.current = setTimeout(() => setCopied(false), 3000);
  }
};

export default Options;
